import { RequestItemType } from '../api/request.types';

export const getIsRequestClosed = (request: RequestItemType) => {
  return request.request.status === 'closed';
};
